export enum InvestigationStatus {
	NotSet = 'Not Set',
	Open = 'Open',
	Concluded = 'Concluded'
}
